import type { ClassroomMenuContent } from './types'

/**
 * Mock data used while the new classroom is being built.
 * Replace with the classroom API payload (same `ClassroomMenuContent` shape).
 */
export const mockTrail: ClassroomMenuContent = {
  id: 'trail-product-design',
  title: 'Formação em Product Design',
  kind: 'trail',
  progress: 75,
  children: [
    {
      id: 'milestone-1',
      kind: 'milestone',
      title: 'Fundamentos da experiência',
      progress: 100,
      children: [
        {
          id: 'course-1',
          kind: 'course',
          title: 'Design centrado no usuário',
          progress: 100,
          children: [
            { id: 'course-1-m1', title: 'Introdução ao design', type: 'pdf', status: 'completed' },
            { id: 'course-1-m2', title: 'Pesquisa com usuários', type: 'audio', status: 'completed' },
            { id: 'course-1-m3', title: 'Mapa de empatia', type: 'scorm', status: 'completed' }
          ]
        }
      ]
    },
    {
      id: 'milestone-2',
      kind: 'milestone',
      title: 'Descoberta e pesquisa',
      progress: 75,
      children: [
        {
          id: 'course-2',
          kind: 'course',
          title: 'Entendendo o problema',
          progress: 75,
          children: [
            { id: 'course-2-m1', title: 'Briefing do projeto', type: 'video', status: 'completed' },
            { id: 'course-2-m2', title: 'Roteiro de entrevistas', type: 'pdf', status: 'in-progress', progress: 60 },
            { id: 'course-2-m3', title: 'Síntese de insights', type: 'audio', status: 'pending' }
          ]
        }
      ]
    },
    {
      id: 'milestone-3',
      kind: 'milestone',
      title: 'Ideação e prototipação',
      progress: 75,
      children: [
        {
          id: 'course-3',
          kind: 'course',
          title: 'Do conceito ao protótipo',
          progress: 100,
          children: [
            { id: 'course-3-m1', title: 'Introdução à prototipação', type: 'video', status: 'completed' },
            { id: 'course-3-m2', title: 'Wireframes de baixa fidelidade', type: 'pdf', status: 'completed' },
            { id: 'course-3-m3', title: 'Biblioteca de componentes', type: 'scorm', status: 'completed' }
          ]
        },
        {
          id: 'course-4',
          kind: 'course',
          title: 'Testes de usabilidade',
          progress: 75,
          children: [
            { id: 'course-4-m1', title: 'Planejando o teste', type: 'pdf', status: 'completed' },
            { id: 'course-4-m2', title: 'Material 2', type: 'audio', status: 'in-progress', progress: 75 },
            { id: 'course-4-m3', title: 'Terceiro material', type: 'scorm', status: 'pending' }
          ]
        },
        {
          id: 'course-5',
          kind: 'course',
          title: 'Prototipação em alta fidelidade',
          progress: 0,
          children: [
            { id: 'course-5-m1', title: 'Design tokens', type: 'video', status: 'pending' },
            { id: 'course-5-m2', title: 'Protótipo navegável', type: 'link', status: 'pending' }
          ]
        }
      ]
    },
    {
      id: 'milestone-4',
      kind: 'milestone',
      title: 'Design visual e sistemas',
      progress: 75,
      children: [
        {
          id: 'course-6',
          kind: 'course',
          title: 'Fundamentos de UI',
          progress: 75,
          children: [
            { id: 'course-6-m1', title: 'Grid, tipografia e cor', type: 'video', status: 'completed' },
            { id: 'course-6-m2', title: 'Acessibilidade na prática', type: 'document', status: 'in-progress', progress: 50 },
            { id: 'course-6-m3', title: 'Galeria de referências', type: 'image', status: 'pending' },
            { id: 'course-6-m4', title: 'Apresentação do módulo', type: 'carousel', status: 'pending' }
          ]
        }
      ]
    },
    {
      id: 'milestone-5',
      kind: 'milestone',
      title: 'Entrega e evolução',
      progress: 0,
      children: [
        {
          id: 'course-7',
          kind: 'course',
          title: 'Handoff e documentação',
          progress: 0,
          children: [
            { id: 'course-7-m1', title: 'Documentando decisões', type: 'pdf', status: 'pending' },
            { id: 'course-7-m2', title: 'Avaliação final', type: 'test', status: 'pending' }
          ]
        }
      ]
    }
  ]
}

export const mockCourse: ClassroomMenuContent = {
  id: 'course-ux-writing',
  title: 'Fundamentos de UX Writing',
  kind: 'course',
  progress: 40,
  children: [
    { id: 'course-ux-m1', title: 'Boas-vindas ao curso', type: 'video', status: 'completed' },
    { id: 'course-ux-m2', title: 'O que é UX Writing', type: 'pdf', status: 'completed' },
    { id: 'course-ux-m3', title: 'Tom e voz da marca', type: 'audio', status: 'in-progress', progress: 40 },
    { id: 'course-ux-m4', title: 'Microcopy na prática', type: 'scorm', status: 'pending' },
    { id: 'course-ux-m5', title: 'Exercício final', type: 'test', status: 'pending' },
    { id: 'course-ux-m6', title: 'Material complementar', type: 'document', status: 'pending' },
    { id: 'course-ux-m7', title: 'Referências externas', type: 'link', status: 'pending' },
    { id: 'course-ux-m8', title: 'Galeria de exemplos', type: 'image', status: 'pending' },
    { id: 'course-ux-m9', title: 'Apresentação do módulo', type: 'carousel', status: 'pending' }
  ]
}
